<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false">
    <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronRightIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>
